module.exports = __webpack_public_path__ + "573a31f59d8ab245261fb52279a91da9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-icons/icon-sky.png
// module id = 2995
// module chunks = 0